var _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmenuActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 39,
    viewBox: "0 0 8 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 19.4688,
    x2: 5,
    y2: 19.4688,
    stroke: "#FF6A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.9375L1 19.4683L1 0.999023",
    stroke: "#FF6A00",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99704 19.4521C6.99704 19.9978 6.56169 20.4297 6.03758 20.4297C5.51348 20.4297 5.07812 19.9978 5.07812 19.4521C5.07812 18.9064 5.51348 18.4746 6.03758 18.4746C6.56169 18.4746 6.99704 18.9064 6.99704 19.4521Z",
    fill: "#FF6A00",
    stroke: "#FF6A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmenuActive);
export default __webpack_public_path__ + "static/media/submenu-active.e54e56b6e4a01a80c67dba9c12956f75.svg";
export { ForwardRef as ReactComponent };